// extracted by mini-css-extract-plugin
var _1 = "ReportTableModalTabBar-moduleReportTableModalTabBar__tYC5e TabList-moduleTabList__ioZlK";
export { _1 as "ReportTableModalTabBar" }
